<template>
  <ConfigurableDashboard dashboard-key="wms" permission-key="WmsDashboard" :default-widgets="['stockValue']" />
</template>
<script>
import ConfigurableDashboard from "../../components/ConfigurableDashboard.vue";

export default {
  name: "WmsDashboard",
  components: { ConfigurableDashboard },
};
</script>
<style scoped></style>
